import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getFLFContextDetail } from "../../../../apis/FLF/context.api";
import ContextDevice from "../../components/ContextDevice/ContextDevice";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { path } from "../../../../constants/path";

const CLAUSE = {
  if: "If",
  then: "Then",
};

const FLFContextDetail = () => {
  let { id } = useParams();
  const [context, setContext] = useState({});

  useEffect(() => {
    if (id) {
      getFLFContextDetail(id, (result) => {
        setContext({ ...result });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div>
      <div style={{ marginBottom: "20px" }}>
        <div className="page-header">
          <h2>FLF Context Detail</h2>
        </div>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href={`${path.flfContext}`}>
            FLF Context
          </Link>
          <Typography color="text.primary">{context.name}</Typography>
        </Breadcrumbs>
      </div>

      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <ContextDevice
          clause={CLAUSE.if}
          contextId={id}
          setContext={setContext}
        />
        <ContextDevice
          clause={CLAUSE.then}
          contextId={id}
          setContext={setContext}
        />
      </div>
    </div>
  );
};

export default FLFContextDetail;
